const sanitize = (value?: string | null) => value?.trim() ?? "";

const fallbackName = "MasterApp";
const fallbackFavicon = "/favicon.ico";

const sanitizedName = sanitize(process.env.NEXT_PUBLIC_BRAND_NAME);
const sanitizedLogo = sanitize(process.env.NEXT_PUBLIC_BRAND_LOGO);
const sanitizedFavicon = sanitize(process.env.NEXT_PUBLIC_BRAND_FAVICON);

export const branding = {
  name: sanitizedName || fallbackName,
  logo: sanitizedLogo || "",
  favicon: sanitizedFavicon || fallbackFavicon,
};
